const TRACKING = {
    cookieName : '_user_cookie_settings',
    optin: document.getElementById('optin'),
    buttons: document.querySelectorAll('.optin__button'),
    settings: document.getElementById('optin__settings'),
    showSettings: document.getElementById('optin__show-settings'),
    onReady() {
        this.gaProperty = 'UA-121958701-2';
        this.hjProperty = 2457972;
        if (TRACKING.optin !== null) {
            TRACKING.showOptin();
            TRACKING.showOptions();
            TRACKING.acceptOptin();
        }
        TRACKING.gaOptout();
        TRACKING.inputChanges();
    },
    showOptin() {
        if ( document.cookie.indexOf(TRACKING.cookieName) != -1 ) {
            TRACKING.optin.remove();
            let cookieValueStr = COOKIE.get({name: TRACKING.cookieName});
            let cookieValueArr = cookieValueStr.split(',');
            TRACKING.activateTracking({settings: cookieValueArr});
        } else {
            TRACKING.optin.style.display = 'block';
        }
    },
    acceptOptin() {
        TRACKING.buttons.forEach(button => { 
            button.addEventListener('click', event => {
                event.preventDefault();
                let cookieSettingsArr = [];
                TRACKING.settings.querySelectorAll('input').forEach(element => {
                    (element.checked) ? cookieSettingsArr.push(element.value + '=true') : cookieSettingsArr.push(element.value + '=false');                    
                });
                const storeDuration     = (cookieSettingsArr.includes('google_analytics=false')) ? 1 : 730;
                const cookieSettingsStr = cookieSettingsArr.toString();
                COOKIE.set({
                    name: TRACKING.cookieName, 
                    value: cookieSettingsStr, 
                    days: storeDuration
                });
                TRACKING.optin.remove();
                TRACKING.activateTracking({settings: cookieSettingsArr});
                TRACKING.writeFile({post: cookieSettingsStr, query: 'cookie-settings'});
                window.location.reload();
            });
        });
    },
    showOptions() {
        TRACKING.showSettings.addEventListener('click', () => {
            TRACKING.settings.style.display = 'block';
            TRACKING.showSettings.remove();
            TRACKING.settings.querySelectorAll('input').forEach( el => {
                el.checked = false;
            });
        });
    },
    /**
    * @settings {array} - Cookie Settings String-Array
    */
    activateTracking({settings}) {
        settings.includes('google_analytics=true') && TRACKING.googleAnalytics();
        settings.includes('google_maps=true') && MAPS.build();
        settings.includes('hotjar=true') && TRACKING.hotJar();
    },
    googleAnalytics() {
        if ( document.cookie.indexOf('_ga_optout') == -1 ) {
            (function(i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function() {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * new Date();
                a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
            ga('create', TRACKING.gaProperty, 'auto');
            ga('set', 'anonymizeIp', true);
            ga('send', 'pageview');
            TRACKING.gaEvents();
        }
    },
    hotJar() {
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:TRACKING.hjProperty,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    },
    gaOptout() {
        let optoutLink = document.getElementById('ga-optout');
        if (optoutLink !== null) {
            optoutLink.addEventListener('click', event => {
                event.preventDefault();
                COOKIE.set({
                    name: '_ga_optout', 
                    value: 'true', 
                    days: 1
                });
                let domain = window.location.hostname.replace('www', '');
                COOKIE.delete({
                    name: TRACKING.cookieName, 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_ga', 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_gid', 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_gat', 
                    domain: domain
                });
                alert('Cookies wurden gelöscht.');
            });
        }
    },
    gaEvents() {
        /******************************
        * EVENT: Scroll
        ******************************/ 
        var maxScrollDepth = 0;
        var maxScrollPercentRound = 0;
        document.addEventListener('scroll', () => {
            var windowHeight       = window.innerHeight;
            var currentScrolldepth = window.scrollY + windowHeight;
            var documentHeight     = document.body.scrollHeight;
            maxScrollDepth         = (currentScrolldepth > maxScrollDepth) ? currentScrolldepth : maxScrollDepth;
            var maxScrollPercent   = maxScrollDepth / documentHeight * 100;
            var currentScrollPercentRound = Math.round(maxScrollPercent / 10) * 10;
            if (currentScrollPercentRound > maxScrollPercentRound) {
                maxScrollPercentRound = currentScrollPercentRound;
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'SCROLL',
                    eventAction:   'SCROLL',
                    eventLabel:    maxScrollPercentRound
                });
            }
        });
        /******************************
        * EVENT: Footer in View
        ******************************/   
        const initalScroll = window.scrollY || window.pageYOffset;
        const footer       = document.querySelector('footer');
        const boundingTop  = footer.getBoundingClientRect().top + initalScroll;
        var seenCounter    = 0; 
        window.addEventListener('scroll', () => {
            var scroll = window.scrollY + window.innerHeight;
            if (scroll > boundingTop) {
                seenCounter++;
                if ( seenCounter === 1 ) {
                    ga('send', {
                        hitType:       'event',
                        eventCategory: 'ELEMENTS',
                        eventAction:   'IN VIEW',
                        eventLabel:    'FOOTER'
                    });
                }
            }
        });
        /******************************
        * EVENT: KLICK -> BTN_INTERN
        ******************************/ 
        let internButtons = document.querySelectorAll('.button--standard');
        internButtons.forEach(button => {
            button.addEventListener('click', () => {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'KLICK',
                    eventAction:   'BTN-INTERN',
                    eventLabel:    button.href
                });
            })
        });
        /******************************
        * EVENT: KLICK -> ACCORDEON
        ******************************/ 
        let dropdowns = document.querySelectorAll('.dropdown__detail');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', () => {
                if ( dropdown.classList.contains('active') === false ) {
                    ga('send', {
                        hitType:       'event',
                        eventCategory: 'KLICK',
                        eventAction:   'OPEN ACCORDEON',
                        eventLabel:    dropdown.querySelector('.dropdown__title').innerHTML
                    });
                }
            });
        });
        /*********************
        * Get URL Parameters
        *********************/
        const queryString = window.location.search;
        const urlParams   = new URLSearchParams(queryString);
        const email       = urlParams.get('email')
        /******************************
        * EVENT: OPTIN -> BESTÄTIGUNG (Leadmagnet)
        ******************************/ 
        if (window.location.href.indexOf('/downloads/') > -1) {
            let urlArr   = window.location.href.split('/');
            let download = urlArr[urlArr.length - 2];
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'BESTÄTIGUNG',
                    eventLabel:    'DOWNLOAD: ' + download + ' / ' + email
                });
            }
        }
        /******************************
        * EVENT: OPTIN -> BESTÄTIGUNG (Simple Double Optin)
        ******************************/ 
        if (window.location.href.indexOf('/subscribe/') > -1) {
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'BESTÄTIGUNG',
                    eventLabel:    'USER: ' + email
                });
            }
        }
        /******************************
        * EVENT: OPTIN -> AUSTRAGUNG (Simple Double Optin)
        ******************************/ 
        if (window.location.href.indexOf('/unsubscribe/') > -1) {
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'AUSTRAGUNG',
                    eventLabel:    'USER: ' + email
                });
            }
        }
    },
    /******************************
    * EVENT: LEAD -> FORM-AUFRUF
    * @form {node}
    * @action {string} : 'FORM-AUFRUF', 'FORM-VERSAND'
    * called in:
        - FORM.sendData()
        - OVERLAY.call()
    ******************************/ 
    formEvents({form, action}) {
        if (form === null) return;
        let cookieSettingsStr = COOKIE.get({name: TRACKING.cookieName});
        let cookieSettingsArr = cookieSettingsStr.split(',');
        if (cookieSettingsArr.includes('google_analytics=false')) return;
        let formWrapper = form.closest('.form-wrapper');
        if (formWrapper === null) return;
        let formName = formWrapper.id;
        ga('send', {
            hitType:       'event',
            eventCategory: 'LEAD',
            eventAction:   action,
            eventLabel:    formName
        });
    },
    /*********************
    * Listen to input changes
    *********************/
    inputChanges() {
        const forms = document.querySelectorAll('.form');
        forms.forEach(form => {
            let inputs = form.querySelectorAll('input');
            inputs.forEach(input => {
                input.addEventListener('change', event => {
                    let source     = form.querySelector('input[name="source"]').value;
                    let postString = `form_name=${form.dataset.formName};;form_temp_id=${form.id};;source=${source};;${input.id}=${input.value}`;
                    (input.classList.contains('form__checkbox') && input.checked) && TRACKING.writeFile({post: postString, query: 'form-tracking'});
                    (input.classList.contains('form__checkbox') === false) && TRACKING.writeFile({post: postString, query: 'form-tracking'});
                });  
            });
        });
    },
    /*********************
    * Write to file
    * @post {string} - stringified post data
    * @query {string} - handler query
    *********************/
    writeFile({post, query}) {
        let getUrl  = window.location;
        let baseUrl = getUrl.protocol + '//' + getUrl.hostname + '/';
        let handler = 'handler.XHR.php?handler=' + query;
        let xhr     = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 && xhr.response === 'success') {
                    // console.log(xhr.response);
                }
            }
        };
        xhr.onerror = (e) => {
            console.log(xhr.response);
        };
        xhr.send(post);
    }
}